import config from "@dust-tt/front/lib/api/config";
import {
  destinationDeDeconnexion,
  porteComptaActive,
} from "@dust-tt/front/lib/compta/connexion/porte";
import { AuthenticatedPage } from "@spa/app/layouts/AuthenticatedPage";
import { UnauthenticatedPage } from "@spa/app/layouts/UnauthenticatedPage";
import { withSuspense } from "@spa/app/routes/withSuspense";
import { useEffect } from "react";
import type { RouteObject } from "react-router-dom";

const JoinPage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/JoinPage"),
  "JoinPage"
);
// Série 2, lot C1: with the home-made login switched on, the invitation link
// leads to our arrival screen (password, profile) instead of WorkOS.
const OnboardingInvitePage = withSuspense(
  () => import("@dust-tt/front/components/pages/compta/OnboardingInvitePage"),
  "OnboardingInvitePage"
);
const LoginErrorPage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/LoginErrorPage"),
  "LoginErrorPage"
);
const InviteChoosePage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/InviteChoosePage"),
  "InviteChoosePage"
);
const NoWorkspacePage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/NoWorkspacePage"),
  "NoWorkspacePage"
);
const SsoEnforcedPage = withSuspense(
  () => import("@dust-tt/front/components/pages/SsoEnforcedPage"),
  "SsoEnforcedPage"
);

// /logout: the self-hosted door closes our session first, otherwise the API
// server's logout endpoint (WorkOS, or the app's for an Astraly app).
function LogoutRedirect() {
  useEffect(() => {
    void destinationDeDeconnexion(config.getApiBaseUrl()).then((destination) =>
      window.location.replace(destination)
    );
  }, []);
  return null;
}

// Authenticated routes (outside workspace scope)
export const loginAuthenticatedRoutes: RouteObject[] = [
  {
    element: <AuthenticatedPage />,
    children: [
      { path: "/invite-choose", element: <InviteChoosePage /> },
      { path: "/no-workspace", element: <NoWorkspacePage /> },
      { path: "/sso-enforced", element: <SsoEnforcedPage /> },
    ],
  },
  { path: "/logout", element: <LogoutRedirect /> },
];

// Unauthenticated routes
export const loginUnauthenticatedRoutes: RouteObject[] = [
  {
    element: <UnauthenticatedPage />,
    children: [
      {
        path: "/w/:wId/join",
        element: porteComptaActive() ? <OnboardingInvitePage /> : <JoinPage />,
      },
      { path: "/login-error", element: <LoginErrorPage /> },
    ],
  },
];
